import React, { useEffect, useState } from 'react';
import {
    Box,
    IconButton,
    Typography,
} from '@mui/material';
import {
    CameraAlt,
    Check,
    Undo,
} from '@mui/icons-material';

import { HasPermissions } from '../../contexts/PermissionContext';
import SettingsCheckBox from '../checkbox/SettingsCheckBox';
import SettingsDropDown from '../dropdown/SettingsDropDown';
import SettingsTextField from '../textfield/SettingsTextField';
import _ from 'lodash';


function ProjectSettings({ schema={}, settings={}, setSettings = () => {} }) {

    const [projectSettings, setProjectSettings] = useState(settings);

    useEffect(() => {
        setProjectSettings(settings)
    }, [settings])

    function handleChange(field, value) {
        const updatedSettings = _.cloneDeep(projectSettings);
        updatedSettings[field] = value;
        updateSettings(updatedSettings);
    }

    function handleDiscard() {
        updateSettings(settings);
    }

    function updateSettings(newSettings) {
        setProjectSettings(newSettings);
        setSettings(newSettings);
    }

    return (
        <Box
            display="flex"
            border={'1px solid rgba(139, 142, 146, 1)'}
            borderRadius={4}
            position="relative"
        >
            {
                !_.isEqual(settings, projectSettings) && 
                <Box
                    position="absolute"
                    top={0}
                    right={0}
                    p={1}
                >
                    <IconButton
                        sx={{
                            color: 'rgba(180, 120, 120, 0.7)', // muted red
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'rgb(211, 47, 47)', // vivid red
                            },
                        }}
                        onClick={handleDiscard}
                    >
                        <Undo
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                    <IconButton
                        sx={{
                            color: 'rgba(120, 180, 120, 0.7)', // muted green
                            fontSize: '16px',
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'rgb(46, 225, 50)', // vivid green
                            },
                        }}
                    >
                        <Check
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                </Box>
            }
            <Box
                m={2}
                display="flex"
                flexDirection="column"
                gap={2}
            >
                <Typography
                    variant="h6"
                >
                    Project Settings
                </Typography>

                <SettingsCheckBox
                    description={schema?.data?.Episodic?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.Episodic?.label ?? 'Production Type'}
                    onChange={(value) => handleChange('Episodic', value)}
                    options={schema?.data?.Episodic?.options ?? []}
                    original={settings?.Episodic ?? ''}
                    value={projectSettings?.Episodic ?? ''}
                />

                <SettingsDropDown
                    description={schema?.data?.FPS?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.FPS?.label ?? 'Frame Rate'}
                    onChange={(value) => handleChange('FPS', value)}
                    options={schema?.data?.FPS?.options ?? []}
                    original={settings?.FPS ?? ''}
                    value={projectSettings?.FPS ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.Resolution?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.Resolution?.label ?? 'Project Resolution'}
                    onChange={(value) => handleChange('Resolution', value)}
                    original={settings?.Resolution ?? ''}
                    value={projectSettings?.Resolution ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.['Audio Order']?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.['Audio Order']?.label ?? 'Audio Order'}
                    onChange={(value) => handleChange('Audio Order', value)}
                    original={settings?.['Audio Order'] ?? ''}
                    value={projectSettings?.['Audio Order'] ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.['Sound Channels']?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.['Sound Channels']?.label ?? 'Sound Channels'}
                    onChange={(value) => handleChange('Sound Channels', value)}
                    original={settings?.['Sound Channels'] ?? ''}
                    value={projectSettings?.['Sound Channels'] ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.Timecode?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.Timecode?.label ?? 'Timecode'}
                    onChange={(value) => handleChange('Timecode', value)}
                    original={settings?.Timecode ?? ''}
                    value={projectSettings?.Timecode ?? ''}
                />

            </Box>
        </Box>
    );
}

export default ProjectSettings;